module.exports = __webpack_public_path__ + "static/media/Hospitality_66.03d3ecab.jpg";